<template>
  <svg
    id="icon-map"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      :fill="fill"
      d="M1.576 19.013c-.427 0-.764-.12-1.011-.362-.247-.241-.371-.575-.371-1.002V5.18c0-.383.077-.708.232-.974.16-.272.417-.507.77-.705L5.649.987A2.29 2.29 0 0 1 6.818.681c.439 0 .85.111 1.234.334l4.759 2.848 4.546-2.523c.21-.118.396-.208.557-.27.167-.067.337-.101.51-.101.427 0 .764.123 1.011.37.248.248.371.582.371 1.003v12.431c0 .384-.08.715-.241.993-.155.278-.408.513-.76.705l-4.463 2.523a2.452 2.452 0 0 1-1.225.325c-.439 0-.866-.114-1.28-.343l-4.806-2.69-4.388 2.374c-.204.118-.39.204-.557.26a1.46 1.46 0 0 1-.51.093Zm4.472-4.5V3.056c-.043.025-.09.052-.14.083-.043.025-.089.05-.138.075l-3.322 1.92a.732.732 0 0 0-.287.25.711.711 0 0 0-.075.353v10.576c0 .161.062.241.186.241.05 0 .114-.021.195-.064l3.58-1.977Zm1.939-.009 3.664 2.06c.056.03.115.062.177.093.068.03.13.061.185.092V5.691l-3.73-2.227a1.793 1.793 0 0 0-.148-.083 1.793 1.793 0 0 0-.148-.084v11.207Zm5.965 2.366c.068-.037.136-.077.204-.12.074-.038.146-.078.214-.121l3.182-1.828a.659.659 0 0 0 .278-.25.676.676 0 0 0 .084-.353V3.696a.226.226 0 0 0-.065-.167.186.186 0 0 0-.149-.065.374.374 0 0 0-.167.056l-3.58 1.957V16.87Z"
    />
  </svg>
</template>

<script>
import { iconPropsFunc } from "./mixins/icons";

export default {
  name: "IconMap",
  mixins: [iconPropsFunc()],
};
</script>

<style lang="scss" scoped></style>
